module.exports = __webpack_public_path__ + "img/mini-logo.b897e4b8.png";